var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Income_ico_O") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large_review",
    transform: "translate(-25.000000, -440.000000)",
    stroke: "#92CDE7",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(25.000000, 424.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Income_ico_O",
    transform: "translate(0.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,0.7499 L11.25,10.4999",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "7.5 7.4999 11.25 10.4999 15 7.4999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-4",
    points: "11.25 19.25 0.75 13.25 0.75 4.25 11.25 10.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-6",
    points: "21.75 13.25 11.25 19.25 11.25 10.25 21.75 4.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8",
    points: "14.2451 0.4975 21.7501 4.2495 11.2501 10.2495 0.7501 4.2495 8.2501 0.4995"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeActive);
export default __webpack_public_path__ + "static/media/income-active.93e068761f18238c4dd9c25780cbaf77.svg";
export { ForwardRef as ReactComponent };